import type { ConfiguredAddOn, ConfiguredService } from '@/features/service-plans';
import { isDateKey, toDateKey, type DateKey } from './dateKey';

export interface AnchorMeta {
    readonly today?: DateKey;
}

interface AnchorState {
    configuredServices: ConfiguredService[];
    configuredAddOns: ConfiguredAddOn[];
    anchorDate?: DateKey | null;
}

export const wireDueDate = (value: string | Date | null | undefined): DateKey | null => {
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value.toISOString().slice(0, 10);
    }
    const key = toDateKey(value);
    return key !== null && isDateKey(key) ? key : null;
};

const datedEntries = (lines: readonly { instanceId: string | number; startDate?: string | Date | null }[]) =>
    lines
        .map((line): [string | number, DateKey | null] => [line.instanceId, wireDueDate(line.startDate)])
        .filter(([, dueDate]) => dueDate !== null)
        .sort();

export const basketDateSignature = (
    services: readonly ConfiguredService[],
    addOns: readonly ConfiguredAddOn[],
): string => JSON.stringify([datedEntries(services), datedEntries(addOns)]);

export const hasDatedLines = (
    services: readonly ConfiguredService[],
    addOns: readonly ConfiguredAddOn[],
): boolean => datedEntries(services).length > 0 || datedEntries(addOns).length > 0;

export const refreshAnchor = (
    state: AnchorState,
    next: { services?: ConfiguredService[]; addOns?: ConfiguredAddOn[] },
    meta: AnchorMeta | undefined,
): void => {
    if (!meta?.today) {
        return;
    }
    const before = basketDateSignature(state.configuredServices, state.configuredAddOns);
    const after = basketDateSignature(next.services ?? state.configuredServices, next.addOns ?? state.configuredAddOns);
    if (before !== after) {
        state.anchorDate = meta.today;
    }
};
